import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11252522"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sf-container" }
const _hoisted_2 = { class: "sf-std-content tw-relative tw-left-0 tw-top-0 tw-text-center" }
const _hoisted_3 = {
  key: 0,
  class: "tw-text-primary"
}
const _hoisted_4 = {
  key: 1,
  class: "tw-text-primary"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-mb-8 tw-max-w-5xl tw-mx-auto" }, " Choose a spelling rule then choose to either practise the spelling or take a test with those words. All words are read aloud (make sure your sound is turned up) and provided within a sentence for context. ", -1))
const _hoisted_6 = { class: "tw-max-w-[900px] tw-mx-auto" }
const _hoisted_7 = {
  key: 1,
  class: "tw-grid tw-gap-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeSpellingRuleCategory = _resolveComponent("HomeSpellingRuleCategory")!
  const _component_HomeSpellingRuleCategoryTree = _resolveComponent("HomeSpellingRuleCategoryTree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (_ctx.$currentUser.value)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_3, " Welcome " + _toDisplayString(_ctx.$currentUser.value.fullName), 1))
          : (_openBlock(), _createElementBlock("h1", _hoisted_4, "Welcome"))
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_ctx.currentCategory)
          ? (_openBlock(), _createBlock(_component_HomeSpellingRuleCategory, {
              key: 0,
              category: _ctx.currentCategory,
              "parent-group": _ctx.parentGroup
            }, null, 8, ["category", "parent-group"]))
          : (_openBlock(), _createElementBlock("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (c, i) => {
                return (_openBlock(), _createBlock(_component_HomeSpellingRuleCategoryTree, {
                  category: c,
                  key: c.id,
                  "expanded-id": _ctx.expandedId,
                  onExpand: _ctx.toggleExpand,
                  class: _normalizeClass([_ctx.getCategoryClass(i), "tw-text-4xl tw-font-bold tw-rounded-2xl tw-text-center hover:tw-outline tw-outline-mainbg1 tw-outline-offset-[-8px]"])
                }, null, 8, ["category", "expanded-id", "onExpand", "class"]))
              }), 128))
            ]))
      ])
    ])
  ]))
}